export default __webpack_public_path__ + "static/betql-image-left-1-db926a9221dd9f7bd36089f35a236b04.webp";